import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import axios from 'axios'

import { URL } from '../../const'
import Chart from '../_common/Chart'
import Loader from '../_common/Loader'

class Dashboard extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      CSV: '#',
      cardsData: null,
      chartData: []
    }
  }

  async componentDidMount () {
    console.log('env: ', process.env.REACT_APP_STAGE)
    this.setState({ loading: true })
    const headers = {
      'Authorization': `Token ${this.props.user.token}`
    }
    const url = `${URL}home`
    try {
      const res = await axios.get(
        url,
        { headers }
      )
      const data = res.data.dashboard
      console.log('data: ', data)
      this.setState({
        CSV: `http://${data.csv_url}` || '#',
        cardsData: data.cards,
        chartData: data.graph,
        loading: false
      })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }

  _handleCsvDownload () {
    console.log('downloading csv')
  }

  render () {
    if (this.state.loading) {
      return <Loader classname="loader_dot_circle" />
    }
    return (
      <section className="dashboard">
        <div className="top_wrapper flex justify-between">
          <div className="warning_indicators flex">
            <Link to="/chat" className="new_messages flex column">
              <div className="title">新着メッセージ</div>
              <div className="number flex justify-center">
                <span className="big">{this.props.chat.waitingCount}</span>
                <span>件</span>
              </div>
            </Link>
            <div className="current_users flex column">
              <div className="title">現在のご利用数</div>
              <div className="number flex justify-center">
                <span className="big">{this.state.cardsData.total_verified_residents}</span>
                <span>件</span>
              </div>
            </div>
          </div>
          <a className="btn download_btn" href={this.state.CSV} target="_blank">
            <div className="svg_container">
              <svg viewBox="0 0 24 24" className="icon_download">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </div>
            <span>CSVダウンロード</span>
          </a>
        </div>

        <div className="card_container flex">
          <Link to="/owners" className="card owner_card">
            <div className="card_title">オーナー</div>
            <div className="card_main">
              <div className="total category">
                <span>全</span>
                <span className="number">{this.state.cardsData.total_owners}</span>
              </div>
              <div className="today category">
                <span>今日</span>
                <span className="number">{this.state.cardsData.today_owners}</span>
              </div>
            </div>
          </Link>
          <Link to="/properties" className="card property_card">
            <div className="card_title">物件</div>
            <div className="card_main">
              <div className="total category">
                <span>全</span>
                <span className="number">{this.state.cardsData.total_properties}</span>
              </div>
              <div className="today category">
                <span>今日</span>
                <span className="number">{this.state.cardsData.today_properties}</span>
              </div>
            </div>
          </Link>
          <Link to="/residents" className="card resident_card">
            <div className="card_title">入居者</div>
            <div className="card_main">
              <div className="total category">
                <span>全</span>
                <span className="number">{this.state.cardsData.total_residents}</span>
              </div>
              <div className="today category">
                <span>今日</span>
                <span className="number">{this.state.cardsData.today_residents}</span>
              </div>
            </div>
          </Link>
          <Link to="/chat" className="card chat_card">
            <div className="card_title">チャット</div>
            <div className="card_main">
              <div className="total category">
                <span>全</span>
                <span className="number">{this.state.cardsData.total_chats}</span>
              </div>
              <div className="waiting_support category">
                <span>対応待ち</span>
                <span className="number">{this.state.cardsData.waiting_support_chats}</span>
              </div>
              <div className="waiting_reply category">
                <span>返事待ち</span>
                <span className="number">{this.state.cardsData.waiting_reply_chats}</span>
              </div>
            </div>
          </Link>
        </div>

        <div className="chart_container">
          <Chart data={this.state.chartData}/>
        </div>
      </section>
    )
  }
}

function mapStateToProps ({ user, chat }) {
  return { user, chat }
}

export default connect(mapStateToProps, null)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js